import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Row, Col, Input } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';
import FilePreviewUploader from '../components/FilePreviewUploader';

function EventTypeAddEdit() {
	const navigate = useNavigate();
	const { editEventTypeId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [form] = Form.useForm();

	const get = () => {
		if (!editEventTypeId) {
			return;
		}
		axios
			.get(`/event-type`, { params: { _id: editEventTypeId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const uplodedFileList = result.data.data[0]?.media?.map((media) => ({
						uid: media._id,
						name: media.mediaTitle,
						status: 'done',
						url: media.mediaPath,
					}));
					if (Array.isArray(uplodedFileList)) {
						setFileList(uplodedFileList);
					}
					form.setFieldsValue(result.data.data[0]);
				}
			})
			.catch(() => {})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editEventTypeId) {
					values._id = editEventTypeId;
				}
				const media = [];

				fileList?.map(({ response }) => {
					if (response?.data?.length) {
						media.push(...response.data);
					}
					return response;
				});
				if (media.length) {
					values.media = media;
				}
				axios({
					method: editEventTypeId ? 'put' : 'post',
					url: '/event-type',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/event-types');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{
						link: '/',
						label: 'Home',
					},
					{
						link: '/event-types',
						label: 'Event Types',
					},
					{
						label: editEventTypeId ? 'Edit' : 'Add',
					},
				]}
			/>
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editEventTypeId ? 'Edit Event Type' : 'Add Event Type'}</div>
						<div className='page-title-more'>
							<Link to='/event-types'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
								Save
							</Button>
						</div>
					</div>
					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Row gutter={[16, 0]}>
								<Col sm={24} md={8}>
									<Form.Item
										label='Event Type'
										name='eventType'
										rules={[
											{
												required: true,
												message: 'Event Type is required',
											},
										]}
									>
										<Input placeholder="For e.g. Winter Special, Weekend Trek, Women's Special" autoFocus />
									</Form.Item>
								</Col>
								<Col sm={24} md={16}>
									<Form.Item label='Description' name='description'>
										<Input style={{ width: '100%' }} />
									</Form.Item>
								</Col>
								<Col sm={24} md={12}>
									<Form.Item label='Photos' name='media'>
										<FilePreviewUploader Form={Form} maxItems={1} fileList={fileList} setFileList={setFileList} aspect={1 / 1} />
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default EventTypeAddEdit;
